var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "user-select-none d-flex",
        { "cursor-pointer": !_vm.onlyChangeOnInputClick },
        { "brb-checkbox": _vm.withBorder },
      ],
      on: {
        click: function ($event) {
          !_vm.onlyChangeOnInputClick
            ? _vm.$refs["brb-checkbox-hidden-input"].click()
            : null
        },
      },
    },
    [
      _c("b-img", {
        class: {
          "ml-2": !!_vm.label,
          "cursor-pointer": _vm.onlyChangeOnInputClick,
        },
        attrs: {
          src: _vm.asset,
          width: "20",
          height: "20",
          alt: _vm.model ? "+" : "-",
        },
        on: {
          click: function ($event) {
            _vm.onlyChangeOnInputClick
              ? _vm.$refs["brb-checkbox-hidden-input"].click()
              : null
          },
        },
      }),
      _vm.label
        ? _c("span", { class: _vm.labelClass }, [
            _vm._v(" " + _vm._s(_vm.label) + " "),
          ])
        : _vm._e(),
      _vm._t("label"),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.model,
            expression: "model",
          },
        ],
        ref: "brb-checkbox-hidden-input",
        attrs: { hidden: "", type: "checkbox" },
        domProps: {
          checked: Array.isArray(_vm.model)
            ? _vm._i(_vm.model, null) > -1
            : _vm.model,
        },
        on: {
          change: function ($event) {
            var $$a = _vm.model,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 && (_vm.model = $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  (_vm.model = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.model = $$c
            }
          },
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }